import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {SimplePresentation, SimplePresentationRunner} from "../../core/winpresentation/SimplePresentationRunner";
import {HTH} from "../HTH";
import {HTHFSIntroPresentation} from "../presentations/maingame/HTHFSIntroPresentation";
import {DropOutPresentation} from "../presentations/avalanche/DropOutPresentation";
import {HTHSuperScatterToSafeConversion} from "../presentations/freespin/HTHSuperScatterToSafeConversion";
import {HTHGameConfig} from "../HTHGameConfig";

export class HTHZeroBetIdlePresentation implements FlowStatePresentation {
    private _flowStateController: FlowStateController;
    private readonly _presentations: SimplePresentation[];

    constructor() {
        this._presentations = [
            new HTHFSIntroPresentation(),
            new HTHSuperScatterToSafeConversion(),
            new DropOutPresentation(),
        ]
    }

    start(flowStateController: FlowStateController): void {
        this._flowStateController = flowStateController;
        HTHGameConfig.bigWinLevelPlayed = [false, false, false, false, false];
        HTHGameConfig.isBigWinLevel5Played = false;
        HTHGameConfig.isSkipped = [false, false];
        HTHGameConfig.lastBigWinPlayedAmount = 0;
        SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }

    public complete() {
        let fsLeft: number = HTH.model.freespinsLeft - 1;

        HTH.apiPlugin.betHandler.zeroBet();
        HTH.keypadPlugin.setZeroBetSpinCounter(fsLeft);
        this._flowStateController.finish();
    }
}